export default "skymp5-front/615881216ef2ce0dd5609a3cd7f32a26.svg";